// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__+iehd","banner":"Home_banner__zeN+Y","main":"Home_main__3ilkD","bookList":"Home_bookList__YEt2J"};